import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import bootstrap from "../../node_modules/bootstrap/dist/js/bootstrap";
import { Fancybox } from "../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm";
import { Carousel } from "../../node_modules/@fancyapps/ui/dist/carousel/carousel.esm";
import { Autoplay } from "../../node_modules/@fancyapps/ui/dist/carousel/carousel.autoplay.esm";
import owl from "../../node_modules/owl.carousel/dist/owl.carousel";
import AOS from "../../node_modules/aos/dist/aos";
import noUiSlider from "../../node_modules/nouislider/dist/nouislider";
import { smoothScroll } from "./components/smooth-scroll.js";

// you can import modules from the theme lib or even from
// NPM packages if they support it…
// import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
// const ExampleModule2 = require('./components/example-2');
const Header = require('./partials/_header.js');
const Animations = require('./partials/_animations.js');
const OwlCarousel = require('./components/owl-carousel.js');
const Empreendimentos = require('./templates/empreendimentos.js');
const Blog = require('./templates/blog.js');

// Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
// import AnimateOnPageLinks from "./components/AnimateOnPageLinks";



// Initialise our components on jQuery.ready…
jQuery(function ($) {
    //     ExampleComponent1.init();
    //     ExampleModule2.init();
    //     ReplaceObfuscatedEmailAddresses.init();
    //     AnimateOnPageLinks.init();

    //ANIMATE ON SCROLL
    AOS.init({
        duration: 1400
    });

    //FANCYBOX
    Fancybox.bind("[data-fancybox]");

    $(".gallery-icon a").attr('data-fancybox', 'blog-gallery');
    Fancybox.bind(".gallery-icon a");


    //FANCYAPP CAROUSEL
    if ($('#myCarousel').length) {
        const container = document.getElementById("myCarousel");
        const options = {
            Autoplay: {
                timeout: 6000,
            }
        };
        new Carousel(container, options, { Autoplay });
    }

    //NOUISLIDER
    if ($('#areaSlider').length) {
        var areaSlider = document.getElementById('areaSlider');
        noUiSlider.create(areaSlider, {
            start: [$(areaSlider).data('min-value'), $(areaSlider).data('max-value')],
            connect: true,
            range: {
                'min': $(areaSlider).data('min-value'),
                'max': $(areaSlider).data('max-value')
            },
            step: 10
        });

        var areaSliderValue = document.getElementById('areaSliderValue');

        areaSlider.noUiSlider.on('update', function (values) {
            areaSliderValue.innerHTML = values[0].replace('.00', '') + ' - ' + values[1].replace('.00', '');
            $(areaSlider).data('value-min-now', values[0].replace('.00', ''));
            $(areaSlider).data('value-max-now', values[1].replace('.00', ''));
        });

        areaSlider.noUiSlider.on('end', function () {
            filtrarImoveis()
        });
    }

  //IMOVEIS FILTRO CHECKBOX
  $('#filtroForm').on('submit', function (e) {
    e.preventDefault(); // Impede o envio padrão do formulário
    filtrarImoveis();
});


//FILTRAR IMOVEIS
function filtrarImoveis() {
    var bairro = $('#imoveisFiltro .filtro .filtro_bairro .form-check-input:checked[type=checkbox]').map(function () {
        return '<span class="selected">' + $(this).siblings('label').text() + '</span>';
    }).get();

    var status = $('#imoveisFiltro .filtro .filtro_status .form-check-input:checked[type=checkbox]').map(function () {
        return '<span class="selected">' + $(this).siblings('label').text() + '</span>';
    }).get();

    var dormitorio = $('#imoveisFiltro .filtro .filtro_dormitorio .form-check-input:checked[type=checkbox]').map(function () {
        return '<span class="selected">' + $(this).siblings('label').text() + '</span>';
    }).get();

    $('#filtroSelecionadoBairro').html(bairro);
    $('#filtroSelecionadoStatus').html(status);
    $('#filtroSelecionadoDormitorio').html(dormitorio);

    $('#imoveisLista').addClass('loading');

    $('#limparChecks').on('click', function (e) {
        e.preventDefault();
        $('#imoveisFiltro .form-check-input:checked').prop('checked', false);
        $('#filtroForm').submit();
    });

    $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: { "action": "filtro-imoveis", bairro: JSON.stringify(bairro), status: JSON.stringify(status), dormitorio: JSON.stringify(dormitorio)},
        success: function (response) {
            $("#imoveisLista").html(response);
            $('#imoveisLista').removeClass('loading');
            ScrollTrigger.refresh();
            return false;
        }
    });
}


//SMOOTH SCROLL - USAR SEMPRE NO FINAL
gsap.registerPlugin(ScrollTrigger);
if ($(".scroll-container").length) {
    var scroller = document.querySelector(".scroll-container");
    smoothScroll(scroller);
}

// gsap.to("#page-home #hero .img-cover",{
//     ScrollTrigger: {
//         trigger:"#page-home",
//         start:"top top",
//         end:"bottom top",
//         scrub:true,
//     } });
});
